import { ReportCategory } from 'app/area/case-report/case-listing/types';

const reportIdMapping = {
  [2]: ReportCategory.NumeratorReport
};
// This is a temporary solution, awaiting backend to support category
export const reportIdToReportCategoryId = (reportId) => {
  return reportIdMapping[reportId];
};
